export const API_ENDPOINTS = {
  BASE_PATH: "/api/staff",
  LOCATIONS: {
    LIST: '/locations',
    MINE: '/locations/mine',
  },
  AUTH: {
    LOGIN: '/token-exchange',
    LOGOUT: '/logout',
    AZURE_LOGIN_URL: '/api/auth/azure/login-url',
    AZURE_VERIFY: '/api/auth/azure/verify'
  },
  STAFF: {
    INFO: '/info',
    SUBMIT: '/submit',
  },
  USERS: {
    LIST: '/users/list',
    VERIFY: '/users/verify',
    COUNT: '/users/count',
  },
  MEAL_INFO: {
    LIST: '/meals/get',
    UPDATE: '/meals/update',
  },
  ACTIVITIES: {
    LIST: '/activities',
    PARTICIPATE: '/activities/participate',
  },
  EVENTS: {
    UPCOMING_EVENTS: '/events/upcoming',
    DETAIL: (id: string) => `/events/${id}`,
    REGISTER: '/events/register',
    UNREGISTER: '/events/unregister',
  },
  DELIVERY: {
    LIST: '/delivery/queue',
    UPDATE: '/delivery/deliver',
    TRANSPORT_LIST: '/delivery/transport-queue',
    TRANSPORT_UPDATE: '/delivery/transport-deliver',
    ACTIVITY_OPTIONS: '/delivery/activity-options',
    ACTIVITY_LIST: '/delivery/activity-queue',
    ACTIVITY_UPDATE: '/delivery/activity-deliver',
  },
  SUBMIT_MEAL_INFO: {
    UPDATE: '/submit',
  },
  PROGRAMS: {
    LIST: '/program/list',
  },
  ADMIN: {
    STAFF: {
      LIST: '/admin/staff',
      CREATE: '/admin/staff',
      DETAIL: (staffId: string) => `/admin/staff/${staffId}`,
      UPDATE: (staffId: string) => `/admin/staff/${staffId}`,
      DELETE: (staffId: string) => `/admin/staff/${staffId}`,
    },
    LOCATIONS: {
      LIST: '/admin/locations',
      CREATE: '/admin/locations',
      DETAIL: (locationId: string) => `/admin/locations/${locationId}`,
      UPDATE: (locationId: string) => `/admin/locations/${locationId}`,
    },
    ACTIVITIES: {
      LIST: '/admin/activities',
      CREATE: '/admin/activities',
      BULK: '/admin/activities/bulk',
      DETAIL: (activityId: string) => `/admin/activities/${activityId}`,
      UPDATE: (activityId: string) => `/admin/activities/${activityId}`,
      STATUS: (activityId: string) => `/admin/activities/${activityId}/status`,
    },
    MEAL_MENUS: {
      LIST: '/admin/meal-menus',
      BULK: '/admin/meal-menus/bulk',
      UPDATE: (dayName: string) => `/admin/meal-menus/${encodeURIComponent(dayName)}`,
    },
  },
  REPORTS: {
    MEALS_ORDERED: '/reports/meals-ordered',
    ACTIVITY: '/reports/activity',
    MEAL_SUMMARY: '/reports/meal-summary',
    TRANSPORT_SUMMARY: '/reports/transport-summary',
  },
  SENIOR_CENTER: {
    APPLICATIONS: {
      LIST: '/senior-center/applications',
      DETAIL: (applicationId: string) => `/senior-center/applications/${applicationId}`,
      FORM: (applicationId: string) => `/senior-center/applications/${applicationId}/form`,
      REVIEW: (applicationId: string) => `/senior-center/applications/${applicationId}/review`,
      REOPEN: (applicationId: string) => `/senior-center/applications/${applicationId}/reopen`,
      TRANSPORTATION_REVIEW: (applicationId: string) =>
        `/senior-center/applications/${applicationId}/transportation/review`,
      ENROLLMENT_SESSION: '/senior-center/enrollment/session',
      REGISTRATION_APPLY: '/senior-center/registration/apply',
    },
  },
  FILE: {
    GET: (fileName: string) => `/api/file/${fileName}`,
  },

} as const;
